import React, { useCallback } from "react";
import { MdOutlineModeEdit } from "react-icons/md";

const CategoryRow = ({
  category,
  data,
  computed,
  isManualEnabled,
  onChange,
  onKgChange,
  onToggleManual,
}) => {

  const handleNumericChange = useCallback(
    (field) => (e) => {
      const { value } = e.target;
      if (value === "" || /^(\d+(\.\d{0,2})?)?$/.test(value)) {
        onChange(field, value);
      }
    },
    [onChange]
  );

  const handleKgChange = useCallback(
    (e) => {
      const { value } = e.target;
      if (value === "" || /^(\d+(\.\d{0,2})?)?$/.test(value)) {
        onKgChange(value);
      }
    },
    [onKgChange]
  );

  if (!data) return null;

  const hasError = !!data.kgError;
  const amountInNaira = computed?.amountInNaira ?? 0;
  const discountPercentage = computed?.discountPercentage ?? 0;
  const isToggled = data.isManualMode;

  return (
    <div className="d-flex align-items-center flex-wrap mb-2">

      {/* KG Input */}
      <div className="mb-3">
        <label className="mb-1 form-label">{category.label}</label>
        <input
          type="text"
          className={`form-control form-control-lg inputStyle ${
            hasError ? "is-invalid" : ""
          }`}
          placeholder="Enter weight in KG"
          value={data.kg}
          onChange={handleKgChange}
        />
        {hasError && (
          <div className="invalid-feedback d-block" style={{ fontSize: "12px" }}>
            {data.kgError}
          </div>
        )}
      </div>

      <span className="mx-3" style={{ color: "#c4da00", fontSize: "20px" }}>
        &#8644;
      </span>

      {/* Amount in Naira (price_per_kg × kg) */}
      <div className="mb-3 mr-3">
        <label className="mb-1 form-label">Amount in Naira</label>
        <input
          type="text"
          className="form-control form-control-lg inputStyle bg-dark text-white"
          placeholder="₦0.00"
          value={`₦${hasError ? 0 : amountInNaira}`}
          disabled
        />
      </div>

      <span className="mx-3" style={{ color: "#c4da00", fontSize: "20px" }}>
        &#8644;
      </span>

      {/* Discount Percentage (tier.discount_percentage — flat % from tier) */}
      <div className="mb-3 mr-3">
        <label className="mb-1 form-label">Discount Percentage</label>
        <input
          type="text"
          className="form-control form-control-lg inputStyle text-black"
          placeholder="0%"
          value={hasError ? "0%" : `${discountPercentage}%`}
          disabled
        />
      </div>

      {/* Manual Mode / Deduction toggle */}
      {isManualEnabled ? (
        <>
          <div
            className="mb-0 percentge d-flex align-items-center justify-content-center"
            style={{
              cursor: "pointer",
              backgroundColor: isToggled ? "#404040" : "#C4DA00",
            }}
            onClick={onToggleManual}
          >
            <MdOutlineModeEdit size={20} color={isToggled ? "#C4DA00" : "#fff"} />
          </div>

          {isToggled && (
            <div className="mb-3 ml-3">
              <label className="mb-1 form-label">Manual Price (per KG)</label>
              <input
                type="text"
                className="form-control form-control-lg inputStyle"
                placeholder="Manual Price (per KG)"
                value={data.manualPrice}
                onChange={handleNumericChange("manualPrice")}
              />
            </div>
          )}
        </>
      ) : (
        <>
          {/* % Deduction toggle — commented out, replaced by discount percentage field above */}
          {/* <div
            className={`mb-0 ${
              data.showDeduction ? "percentageDark" : "percentge"
            } d-flex align-items-center justify-content-center`}
            style={{ cursor: "pointer" }}
            onClick={() => onChange("showDeduction", !data.showDeduction)}
          >
            <p className="mb-0">%</p>
          </div>

          {data.showDeduction && (
            <div className="mb-3 ml-3">
              <label className="mb-1 form-label">Deduction in Percentage</label>
              <input
                type="text"
                className="form-control form-control-lg inputStyle"
                placeholder="% Deduction"
                value={data.deduction}
                onChange={handleNumericChange("deduction")}
                disabled={!data.kg || data.kg === "0" || !!data.kgError}
              />
            </div>
          )} */}
        </>
      )}
    </div>
  );
};

export default CategoryRow;